<div>
  <div class="flex justify-end m-2">
    <button mat-raised-button (click)="openCreateDialog()" color="accent">
      Create new College
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="m-5">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z8"
      matTableResponsive
    >
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      <!-- College name column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let college">{{ college.name }}</td>
      </ng-container>

      <!-- email domain column -->
      <ng-container matColumnDef="emailDomain">
        <th mat-header-cell *matHeaderCellDef>Email Domain</th>
        <td mat-cell *matCellDef="let college">{{ college.emailDomain }}</td>
      </ng-container>

      <!-- status column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let college">{{ college.status }}</td>
      </ng-container>

      <!-- campuses column -->
      <ng-container matColumnDef="campuses">
        <th mat-header-cell *matHeaderCellDef># of Campuses</th>
        <td
          mat-cell
          *matCellDef="let college"
          class="justify-center align-center"
        >
          <div *ngIf="college.campuses.length == 0">
            <button mat-button extended color="accent">
              {{ college.campuses.length }}
            </button>
          </div>
          <div *ngIf="college.campuses.length >= 1">
            <button
              mat-button
              extended
              (click)="navigateToCampus(college.id)"
              matTooltip="View List of Campuses"
              color="accent"
            >
              {{ college.campuses.length }}
              <mat-icon> pageview </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- manage column -->
      <ng-container matColumnDef="manage">
        <th mat-header-cell *matHeaderCellDef>Manage</th>
        <td mat-cell *matCellDef="let college">
          <div class="flex-row">
            <button
              mat-mini-fab
              (click)="openEditDialog(college)"
              matTooltip="Edit"
              class="mr-2"
            >
              <mat-icon> edit </mat-icon>
            </button>
            <button
              mat-mini-fab
              (click)="openDeleteDialog(college)"
              matTooltip="Delete"
            >
              <mat-icon> delete </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of colleges"
  >
  </mat-paginator>
</div>
